<template>
  <v-container fluid grid-list-md pb-12 :class="{'px-0': $vuetify.breakpoint.smAndDown}" id="page-body">
    <rsscards newsSource="msnbc-top" displayTitle="Top"></rsscards>
    <rsscards newsSource="msnbc-world" displayTitle="World"></rsscards>
    <rsscards newsSource="msnbc-us" displayTitle="US"></rsscards>
    <rsscards newsSource="local" displayTitle="Mission Viejo Patch" displayThumb="true" className="patch card-with-image"></rsscards>
  </v-container>
</template>

<script>
export default {
  name: 'News'
}
</script>
